import { useEffect, useRef, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { makeStyles, Box } from '@material-ui/core';


// ⚙️ Se aplica UNA sola vez el tema global
am4core.useTheme(am4themes_animated);

const stylesDescriptionCut = { fontSize: '13px' };

const useStyles = makeStyles(theme => ({
    container: {
        position: 'absolute',
        top: '53%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        color: '#666666',
        textAlign: 'center',
    },
    containerChart: {
        height: '100%',
        bottom: '10px'
    },
    containerValueUnity: {
        margin: theme.spacing(4, 0, 0,)
    },
    unity: {
        color: theme.palette.grey.hairline,
        fontSize: theme.spacing(3)
    },
    value: {
        color: theme.palette.grey.hairline,
        fontWeight: "600",
        fontSize: theme.spacing(3)
    },
    variableName: {
        color: theme.palette.grey.hairline,
        margin: theme.spacing(1, 0, 0, 0),
        fontSize: theme.spacing(2)
    },
    chart: { height: "100%", width: "100%" },
    mainTitle: {
        padding: theme.spacing(2, 1, 0, 4),
        color: theme.palette.grey.hairline,
        fontSize: theme.spacing(1.7),
        fontWeight: "600",
        height: '45px'
    },
    subTitle: { fontWeight: '400' },
    dateFooter: {
        fontSize: theme.spacing(1.5),
        color: '#595555',
    },
}));

// Evitar recrear objetos por defecto
const defaultUnityConfig = { base_unit: '' };
const defaultPositions = { h: 2 };

export default function DynamicGauge({
    id = 'gauge-default',
    color = '#4caf50',
    descripcion = 'Sin descripción',
    title = 'Gauge',
    min = 0,
    max = 100,
    value = 0,
    unityConfig = defaultUnityConfig,
    positions = defaultPositions,
    timestamp = null
}) {
    const classes = useStyles();
    const chartRef = useRef(null);

    const [dinamycSize, setDinamycSize] = useState({
        title: false,
        unity: false,
        description: false
    });

    // ------------------- CREA EL GAUGE -------------------
    useEffect(() => {
        if (!id) return;
        let chart;
        try {
            chart = am4core.create(id, am4charts.GaugeChart);
            chartRef.current = chart;
            if (chart.logo) chart.logo.disabled = true;
            const axis = chart.xAxes.push(new am4charts.ValueAxis());
            const baseUnit = unityConfig?.base_unit || '';
            if (baseUnit === 'A') chart.numberFormatter.numberFormat = `#.##'A'`;
            else if (baseUnit[0] === 'k') chart.numberFormatter.numberFormat = `#.## ${baseUnit}`;
            else if (baseUnit === '') chart.numberFormatter.numberFormat = `#.##`;
            else chart.numberFormatter.numberFormat = `#.##a${baseUnit}`;
            axis.min = Number(min) || 0;
            axis.max = Number(max) || 100;
            axis.renderer.grid.template.disabled = true;
            axis.renderer.labels.template.radius = am4core.percent(3);
            axis.renderer.labels.template.fontSize = 12;
            axis.renderer.minGridDistance = 100;
            chart.startAngle = -225;
            chart.endAngle = 45;
            chart.innerRadius = am4core.percent(88);
            // Fondo gris
            const range1 = axis.axisRanges.create();
            range1.value = axis.min;
            range1.endValue = axis.max;
            range1.axisFill.fillOpacity = 1;
            range1.axisFill.fill = am4core.color('#d2d0d0b3');
            range1.axisFill.zIndex = 1;
            // Valor actual
            const range2 = axis.axisRanges.create();
            range2.endValue = value ?? 0;
            range2.axisFill.fillOpacity = 1;
            range2.axisFill.fill = am4core.color(color);
            range2.axisFill.zIndex = 1;
        }
        catch (err) {
            console.warn("⚠️ Error al crear el gráfico:", err);
        }

        return () => {
            chart?.dispose();
        };
        // eslint-disable-next-line
    }, [color, id, min, max]);

    // ------------------- ACTUALIZA VALOR -------------------
    useEffect(() => {
        const chart = chartRef.current;
        if (chart?.xAxes?.getIndex(0)?.axisRanges?.getIndex(1)) {
            try {
                const range2 = chart.xAxes.getIndex(0).axisRanges.getIndex(1);
                range2.endValue = value ?? 0;
                chart.validateData();
            } catch {
                console.warn("⚠️ No se pudo actualizar el valor del gauge");
            }
        }
    }, [value]);

    // ------------------- AJUSTE DE TAMAÑO -------------------
    useEffect(() => {
        const height = positions?.h ?? 2;
        const sizes = {
            title: height > 2,
            unity: height > 2,
            description: height > 2,
            date: height < 3
        };
        setDinamycSize(sizes);
    }, [positions]);

    // ------------------- RENDER -------------------
    return (
        <Box height="100%">
            <Box className={classes.containerChart}>
                <Box className={classes.chart} id={id} />
                <Box className={classes.container}>
                    <Box className={classes.containerValueUnity}>
                        <Box
                            className={classes.value}
                            style={dinamycSize.title ? { fontSize: '40px' } : {}}
                        >
                            {value}
                        </Box>
                    </Box>

                    {/* <Box
                        style={dinamycSize.description ? { fontSize: '19px' } : { ...stylesDescriptionCut }}
                        className={classes.variableName}
                    >
                        {descripcion}
                    </Box> */}

                </Box>
            </Box>
        </Box>
    );
}
